"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plainCirclePath = exports.squigglyCirclePath = void 0;
const STEPS = 240;
/**
 * Build a closed SVG path tracing a wavy circle centered at `(center, center)`
 * with the given `meanRadius`. `lobes` controls how many bumps go around the
 * loop, `amplitude` controls how far the path deviates from the mean radius.
 */
const squigglyCirclePath = (center, meanRadius, lobes, amplitude) => {
    let path = '';
    for (let i = 0; i <= STEPS; i++) {
        const t = (i / STEPS) * Math.PI * 2;
        const r = meanRadius + amplitude * Math.sin(lobes * t);
        const x = center + r * Math.cos(t);
        const y = center + r * Math.sin(t);
        path += i === 0 ? `M${x.toFixed(2)} ${y.toFixed(2)}` : ` L${x.toFixed(2)} ${y.toFixed(2)}`;
    }
    return path + ' Z';
};
exports.squigglyCirclePath = squigglyCirclePath;
/**
 * SVG path tracing a plain (non-squiggly) circle centered at `(center, center)`.
 * Used for ring/halo strokes when the style is `solid`, `dashed`, or `dotted`.
 */
const plainCirclePath = (center, radius) => `M ${center} ${center - radius} ` +
    `A ${radius} ${radius} 0 1 1 ${center} ${center + radius} ` +
    `A ${radius} ${radius} 0 1 1 ${center} ${center - radius} Z`;
exports.plainCirclePath = plainCirclePath;
